import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'
import AppConstants from '../constants/app.constants'
import { store } from '../store'
import ErrorMessageUtils from '../_helpers/error-message.util'

const retryTimeout = 1

export default class SocketHandler {
  constructor(onMessageSettingWizard, onMessage, onError, onConnected) {
    this.stompClient = null
    this.showSocketErrorMsg = false
    this.onMessage = onMessage
    this.onMessageSettingWizard = onMessageSettingWizard
    this.onError = onError
    this.onConnected = onConnected
  }

  init() {
    this.needRetryOnClose = true
    this.connect()
    this.initNetworkEvents()
  }
  connect() {
    // Websocketクライアントを作成する
    this.socket = new SockJS(
      `${process.env.WEB_SOCKET_ENDPOINT}/db-change`
    )
    this.stompClient = Stomp.over(this.socket)
    if (!this.stompClient) {
      return
    }
    // デバッグをオフにします
    this.stompClient.debug = () => {
      // 何もしない
    }
    // ソケットサーバーを接続します
    this.stompClient.connect(
      {},
      _frame => {
        // 接続状態を更新する
        console.log('Socket connected successfully.')
        store.commit('setReconnectedFlag', true)
        this.connected = true
        // 再試行間隔をクリアし、エラーメッセージを非表示にします
        this.clearSocketInterval()
        this.onConnected()
        this.showSocketErrorMsg = false
        // SocketServerからの新しいメッセージをサブスクライブする
        this.stompClient.subscribe(
          AppConstants.TOPIC_DB_CHANGE,
          async res => {
            await this.onMessage(res)
          }
        )
        this.stompClient.subscribe(
          AppConstants.TOPIC_SETUP_CHANGE,
          async res => {
            await this.onMessageSettingWizard(res)
          }
        )
      },
      error => {
        // 接続を再試行します
        console.error('Web socket error: ', error)
        this.reconnect()
      }
    )
    this.socket.onclose = async e => {
      // 接続を再試行します
      console.log('Socket is closed:', e.reason)
      store.commit('setReconnectedFlag', false)
      if (this.needRetryOnClose) {
        this.reconnect()
      }
      await ErrorMessageUtils.checkToShowDisconnectionErrorMsg(e, false)
    }
    this.socket.onerror = e => {
      // 接続を再試行します
      console.error('Socket encountered error:', e, 'Closing socket...')
      this.reconnect()
    }
  }

  disconnect() {
    if (this.stompClient) {
      this.stompClient.disconnect()
    }
  }

  close() {
    this.needRetryOnClose = false
    this.clearSocketInterval()
    this.disconnect()
    if (this.socket) {
      this.socket.close()
    }
    console.log('Socket disconnected')
  }

  getMessage(res) {
    if (!res) {
      return null
    }
    const result = JSON.parse(res.body)
    return result
  }

  initNetworkEvents() {
    window.addEventListener('offline', () => {
      console.log('Network offline event received')
      // 接続を再試行します
      this.reconnect()
    })
  }

  get connectedStatus() {
    return this.connected
  }

  reconnect() {
    // 接続ステータスを更新し、エラーメッセージを表示する
    this.connected = false
    if (!this.showSocketErrorMsg) {
      this.showSocketErrorMsg = true
      this.onError()
    }
    // 間隔で接続を再試行します
    this.clearSocketInterval()
    this.socketInterval = setTimeout(() => {
      this.disconnect()
      this.connect()
    }, retryTimeout * 1000)
  }

  clearSocketInterval() {
    if (this.socketInterval) {
      clearTimeout(this.socketInterval)
      this.socketInterval = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/socket-handler.js